export default __webpack_public_path__ + "static/pod_device-e69a087a3eff404a352f7b69efb7ab77.png";